import React from "react";
import "../../src/App.css";

function AccessibilityPolicy() {
  return (
    <div className="page-content">
      <h1>Accessibility Policy</h1>
      <p>
        <strong>Last Updated:</strong> May 13, 2025
      </p>
      <p>
        multido.com is committed to ensuring that our application is accessible
        to all users, including those with disabilities. We strive to meet or
        exceed the standards outlined in the Web Content Accessibility
        Guidelines (WCAG) 2.1 Level AA.
      </p>
      <h2>1. Our Commitment</h2>
      <p>
        We aim to make multido.com accessible by:
        <ul>
          <li>Providing keyboard navigation for all interactive elements.</li>
          <li>Ensuring sufficient color contrast for text and UI elements.</li>
          <li>
            Using semantic HTML and ARIA landmarks for better screen reader
            support.
          </li>
          <li>Providing alt text for icons and images where applicable.</li>
        </ul>
      </p>
      <h2>2. Ongoing Efforts</h2>
      <p>
        We are continuously working to improve accessibility by:
        <ul>
          <li>Conducting regular accessibility audits.</li>
          <li>Training our team on accessibility best practices.</li>
          <li>Responding to user feedback about accessibility issues.</li>
        </ul>
      </p>
      <h2>3. Known Limitations</h2>
      <p>
        Some areas of multido.com may currently have accessibility limitations:
        <ul>
          <li>
            The date picker for deadline tasks may not be fully accessible to
            screen readers (we are working on a solution).
          </li>
          <li>
            Complex task hierarchies may be challenging to navigate via keyboard
            (planned improvements in future updates).
          </li>
        </ul>
      </p>
      <h2>4. Feedback</h2>
      <p>
        We welcome feedback on how we can improve accessibility. If you
        encounter any issues, please contact us at{" "}
        <a href="mailto:accessibility@multido.com">accessibility@multido.com</a>
        .
      </p>
    </div>
  );
}

export default AccessibilityPolicy;
